import { Route, Routes, useLocation } from 'react-router';
import { Loading } from '@carbon/react';
import { useAuth } from './auth/AuthContext';
import { LoginPage } from './pages/Login';
import { Shell } from './layout/Shell';
import { ROUTES, routeOpen } from './routes';
import { EmptyState } from './components/states';
import { LoiTrang } from './components/LoiTrang';

function Forbidden() {
  return <div className="page"><EmptyState title="Không có quyền" body="Vai trò của bạn không mở được trang này. Nhờ chủ sở hữu cấp quyền nếu cần." /></div>;
}

export function App() {
  const { me, ready, can } = useAuth();
  const loc = useLocation();
  if (!ready) return <Loading withOverlay description="Đang tải" />;
  if (!me) return <LoginPage />;
  return (
    <Shell>
      <LoiTrang khoa={loc.pathname}>
      <Routes>
        {ROUTES.map((r) => <Route key={r.path} path={r.path} element={routeOpen(r, can, me?.role) ? r.element : <Forbidden />} />)}
        <Route path="*" element={<div className="page"><EmptyState title="Không có trang này" body="Đường dẫn không tồn tại. Chọn một mục trong menu bên trái." /></div>} />
      </Routes>
      </LoiTrang>
    </Shell>
  );
}
